module.exports = __webpack_public_path__ + "static/media/don_aero_img.32a40db7.jpg";